import { render, staticRenderFns } from "./SfHeaderNavigation.vue?vue&type=template&id=a93c31a6"
import script from "./SfHeaderNavigation.vue?vue&type=script&lang=js"
export * from "./SfHeaderNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports